import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { withTranslation } from 'react-i18next'

import { Button } from '../../../..'
import { DeviceMessageModal } from '../../../../../containers/Estate/Store/CustomMessages'
import { getCustomMessagesFromLayerExtra } from '../../../../../reducers/customMessages'

const StyledButton = styled(Button)`
    font-size: 12px;
    padding: 3px 5px;
`

function CustomMessageButton({ device, layerExtra, onClick, t }) {
    let customMessages = getCustomMessagesFromLayerExtra(layerExtra)

    // Force customMessages to be an array
    switch (typeof customMessages) {
        case 'string':
            customMessages = [customMessages]
            break
        case 'undefined':
            customMessages = []
            break
        default:
    }

    const renderButton = () => {
        if (customMessages.length === 0) {
            const title = t('device-custom-message-count', { context: '0' })

            return (
                <StyledButton forceWidth onClick={onClick} size="md" theme="disabled" title={title}>
                    {title}
                </StyledButton>
            )
        }

        if (customMessages.length === 1) {
            const title = customMessages[0]

            return (
                <StyledButton forceWidth onClick={onClick} size="md" title={title}>
                    {title}
                </StyledButton>
            )
        }

        const title = t('device-custom-message-count', {
            count: customMessages.length,
        })

        return (
            <StyledButton forceWidth onClick={onClick} size="md" title={title}>
                {title}
            </StyledButton>
        )
    }

    return (
        <DeviceMessageModal device={device} layerExtra={layerExtra}>
            {renderButton()}
        </DeviceMessageModal>
    )
}

CustomMessageButton.propTypes = {
    device: PropTypes.string,
    layerExtra: PropTypes.shape({}),
    onClick: PropTypes.func,
    t: PropTypes.func.isRequired,
}

CustomMessageButton.defaultProps = {
    device: null,
    layerExtra: {},
    onClick: () => null,
}

export default withTranslation()(CustomMessageButton)
